var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('event-navbar',{attrs:{"title":"Session"}}),_c('div',{staticClass:"container-fluid"},[_c('talk-detail-page',{attrs:{"talkId":_vm.$route.params.talkId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }